import React, { useEffect } from 'react';
import { classname } from 'utils';
import './dark-wrapper.css';
import createAnnotationListener from '../../../utils/createAnnotationsLinks';

const DarkWrapper = ({ children }) => {
  const cl = classname('dark-wrapper');

  /* Костыль для аннотации у ссылок */
  useEffect(() => {
    const links = [...document.querySelectorAll('[type="annotation"]')];
    links.forEach(createAnnotationListener);
  }, []);

  return (
    <div className={cl()}>
      {children}
      <div style={{ height: '1px' }} />
    </div>
  );
};

export default DarkWrapper;
